module.exports = __webpack_public_path__ + "img/logout.47af7eb7.svg";